module.exports = __webpack_public_path__ + "static/media/updaptULogo.adaf1b20.svg";